import {isChrome, isIPadDevice} from "./helpers";

const IPAD_FIX_INPUT_ID = 'ipadFix';

export const fixIpadViewport = () => {
  if (!isIPadDevice() || !isChrome()) {
    return
  }

  if (document.getElementById(IPAD_FIX_INPUT_ID)) {
    return
  }

  // Hidden input: focusing/blurring it once on the first touch makes iPad Chrome
  // recalculate the viewport. It must stay focusable, so no display:none / visibility:hidden.
  const wrapper = document.createElement('div');
  wrapper.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;z-index:-1;';

  const input = document.createElement('input');
  input.type = 'text';
  input.id = IPAD_FIX_INPUT_ID;
  input.tabIndex = -1;
  input.setAttribute('aria-hidden', 'true');
  input.setAttribute('autocomplete', 'off');
  // font-size >= 16px prevents iOS from auto-zooming when the input gets focus
  input.style.cssText = 'font-size:16px;border:0;padding:0;margin:0;width:1px;height:1px;';

  wrapper.appendChild(input);
  document.body.appendChild(wrapper);

  const handleFirstTouch = () => {
    document.removeEventListener('touchstart', handleFirstTouch);
    input.focus();
    setTimeout(() => {
      input.blur();
      wrapper.remove();
    }, 0);
  };

  document.addEventListener('touchstart', handleFirstTouch);
}
